'use client';

import { useIdPath } from '@/contexts/IdPathProvider';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import Smartlook from 'smartlook-client';
import { useSession } from 'next-auth/react';
import { resolveAuthContext } from '@/utils/auth-context';

export default function SmartlookAnalytics() {
    const { isLoading, idPath } = useIdPath();
    const pathname = usePathname();
    const { data: session } = useSession();

    useEffect(() => {
        if (isLoading) return;

        // Chỉ xử lý khi có idPath (đã load xong cấu hình)
        if (!idPath) return;

        if (!pathname) return;
        const lowerPath = pathname.toLowerCase();
        // Kiểm tra nếu url chứa /admin (vd: /admin, /smart-facility-360/qtsc/admin)
        // hoặc bắt đầu bằng /project (vd: /project)
        const isExcluded = lowerPath.includes('/admin') || lowerPath === '/project' || lowerPath.startsWith('/project/');
        
        // Nếu Heritage page nhưng nhận Admin session → không init Smartlook
        const isContaminated = resolveAuthContext(pathname) === 'HERITAGE' && (session as any)?.id_path === 'default';

        const smartlookKey = process.env.NEXT_PUBLIC_SMARTLOOK_KEY;
        if (!smartlookKey) return;

        if (isExcluded || isContaminated) {
            // Tạm dừng tracking nếu ở trang không cho phép
            try {
                Smartlook.pause();
            } catch (e) {
                console.error("Smartlook pause error", e);
            }
            return;
        }

        // Khởi tạo Smartlook nếu đang ở trang hợp lệ
        Smartlook.init(smartlookKey);
        
        // Đảm bảo tiếp tục record nếu trước đó đã bị pause vì vào trang admin
        try {
            Smartlook.resume();
        } catch (e) {
            // bỏ qua
        }
    }, [isLoading, idPath, pathname, (session as any)?.id_path]);

    return null;
}
